<template>
  <!-- 能耗概览 -->
  <div class="energyOverview app-bg">
    <el-col :span="16">
      <el-row :gutter="20" align="center">
        <el-col :span="8">
          <div class="count01">
            <h1>年总用电量（Kwh）</h1>
            <h2>564</h2>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="count02" @click="toggle(1)">
            <h1>年总用电量同比（Kwh）</h1>
            <h2>46</h2>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="count03" @click="toggle(3)">
            <h1>年用电量同比变化率</h1>
            <h2>18%</h2>
          </div>
        </el-col>
      </el-row>
    </el-col>
   
    <el-row>
      <el-col :span="24">
        <h1 class="tableTitle">能耗用量详情</h1>
        <el-row>
          <el-col :span="6">
            区域：
            <el-select clearable :placeholder="区域"  v-model="queryParams.area">
              <el-option
                v-for="item in areaTypeList"
                :key="item.itemCode"
                :value="item.itemCode"
                :label="item.itemName"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            楼栋：
            <el-select clearable :placeholder="楼栋" v-model="queryParams.building">
              <el-option
                v-for="item in buildingTypeList"
                :key="item.itemCode"
                :value="item.itemCode"
                :label="item.itemName"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            单元：
            <el-select clearable :placeholder="单元"  v-model="queryParams.unit">
              <el-option
                v-for="item in unitTypeList"
                :key="item.itemCode"
                :value="item.itemCode"
                :label="item.itemName"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            二级：
            <el-select clearable :placeholder="分项类型"  v-model="queryParams.l2type">
              <el-option
                v-for="item in l2TypeList"
                :key="item.itemCode"
                :value="item.itemCode"
                :label="item.itemName"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            三级：
            <el-select clearable :placeholder="分项类型" v-model="queryParams.l3type">
              <el-option
                v-for="item in l3TypeList"
                :key="item.itemCode"
                :value="item.itemCode"
                :label="item.itemName"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            周期:
            <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
                v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                  @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          </el-col>
          <el-col :span="4">
            <el-button
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              :loading="listLoading"
               @click="handleQuery"
            >
              {{
              $t('commons.search') }}
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">

            <el-table v-loading="loading" :data="quotaList">                    
                <el-table-column label="月份" align="center" prop="energyMonth" />
                <el-table-column label="区域" align="center" prop="area" />
                <el-table-column label="楼栋" align="center" prop="building" />
                <el-table-column label="单元" align="center" prop="unit" />
                <el-table-column label="二级" align="center" prop="l2type" />
                 <el-table-column label="三级" align="center" prop="l3type" />
                <el-table-column label="用电量" align="center" prop="useusage" />
               </el-table>
               <pagination
                  v-show="total>0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"
                />
            
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
  <!-- 月份 总用电量 实验设备 冷链设备 送排风 给排水 风机盘管 风冷机组 公共照明 照明插座 电梯用电 安防用电 -->
</template>
<script>
// 导入主题，引用时在v-chart中增加theme="macarons"
import "echarts/theme/macarons";
import {
  getLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getAirconditionLevel2,//空调
  listAircondition,//空调
  getPowerchildLevel2,//动力
  listPowerchild,//动力
  getLightchildLevel2,//照明
  listLightchild,//照明
  getSpecialchildLevel2,//特殊用电
  listSpecialchild,//特殊用电

} from "@/api/business/energy/consumption";
export default {
  name: "energyOverview",
  data() {
    return {
        useusage: "",
      changeusage: "",
      changerate: "",
      hotYear: "",
      othersYear: "",
       list: null,
          // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   energytype: null,
                   area: null,
                   building: null,
                   unit: null,
                   l2type: null,
                   l3type: null,
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
     
      l2TypeList: [
        { itemCode: 1, itemName: "自定义L2-1" },
        { itemCode: 2, itemName: "自定义L2-2" },
        { itemCode: 3, itemName: "自定义L2-3" },
        { itemCode: 4, itemName: "自定义L2-4" },
      ],
      l3TypeList: [
        { itemCode: 1, itemName: "自定义L3-1" },
        { itemCode: 2, itemName: "自定义L3-2" },
        { itemCode: 3, itemName: "自定义L3-3" },
        { itemCode: 4, itemName: "自定义L3-4" },
      ],
      areaTypeList: [
         { itemCode: 1, itemName: "一区" },
        { itemCode: 2, itemName: "二区" },
        { itemCode: 3, itemName: "三区" },
        { itemCode: 4, itemName: "四区" },
      ],
      buildingTypeList: [
        { itemCode: 1, itemName: "1号楼" },
        { itemCode: 2, itemName: "2号楼" },
        { itemCode: 3, itemName: "3号楼" },
        { itemCode: 4, itemName: "4号楼" },
      ],
      unitTypeList: [
        { itemCode: 1, itemName: "1单元" },
        { itemCode: 2, itemName: "2单元" },
        { itemCode: 3, itemName: "3单元" },
        { itemCode: 4, itemName: "4单元" },
      ],
       
      dayData: [
        {
          name: "空调用电（Kwh）",
          count: 564,
          proportion: 25,
        },
        {
          name: "照明用电（Kwh）",
          count: 164,
          proportion: 20,
        },
        {
          name: "动力用电（Kwh）",
          count: 265,
          proportion: 20,
        },
        {
          name: "特殊用电（Kwh）",
          count: 455,
          proportion: 35,
        },
      ],
      monthData: [
        {
          name: "空调用电（Kwh）",
          count: 5646,
          proportion: 20,
        },
        {
          name: "照明用电（Kwh）",
          count: 5646,
          proportion: 30,
        },
        {
          name: "动力用电（Kwh）",
          count: 5646,
          proportion: 30,
        },
        {
          name: "特殊用电（Kwh）",
          count: 5646,
          proportion: 20,
        },
      ],
      yearData: [
        {
          name: "年空调用电（Kwh）",
          count: 56465,
          proportion: 20,
        },
        {
          name: "年照明用电（Kwh）",
          count: 10065,
          proportion: 20,
        },
        {
          name: "年动力用电（Kwh）",
          count: 46465,
          proportion: 20,
        },
        {
          name: "年特殊用电（Kwh）",
          count: 16465,
          proportion: 40,
        },
      ],
      paramsData: [],
      initData: null,
      electricityProportionOptions: null,
      monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
    };
  },
  created() {
    this.initData = this.dayData;
    this.paramsData = [
      { value: this.initData[0].count, name: this.initData[0].name },
      { value: this.initData[1].count, name: this.initData[1].name },
      { value: this.initData[2].count, name: this.initData[2].name },
      { value: this.initData[3].count, name: this.initData[3].name },
    ];
    this.electricityProportionOptions = this.electricityProportion(
      this.paramsData
    );
    this.monthlyProportionOptions = this.monthlyProportion();
    this.monthlyProportionOptionsRate = this.monthlyProportionRate();
    this.monthlyProportionOptionsRate2 = this.monthlyProportionRate2();
    this.yearlyProportionOptions = this.yearlyProportion();
    this.seasonProportionOptions = this.seasonProportion();
    this.seasonProportionOptionsRate = this.seasonProportionRate();
    this.seasonProportionOptionsRate2 = this.seasonProportionRate2();
    this.yearlyProportionOptionsRate = this.yearlyProportionRate();
    this.yearlyProportionOptionsRate2 = this.yearlyProportionRate2();
  },
  computed: {},
  methods: {
      // 设置日期范围查询条件
     setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },

        /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;
      listAircondition(this.queryParams).then((response) => {
       this.quotaList = response.rows;
   
        this.total = response.total;
        this.loading = false;
      });
    },
    electricityProportion() {
      return {
        color: ["#409eff", "#67C23A", "#E6A23C", "#F56C6C"],
        title: {
          text: "分项占比",
          x: "50",
          y: "0",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          x: "right",
          top: "center",
          align: "left",
          data: [
            "空调用电（Kwh）",
            "照明用电（Kwh）",
            "动力用电（Kwh）",
            "特殊用电（Kwh）",
          ],
        },
        series: [
          {
            name: "分项占比",
            type: "pie",
            center: ["40%", "50%"],
            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.paramsData,
          },
        ],
      };
    },
    monthlyProportion() {
      return {
        title: {
          text: "年度用量同比",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "用电量(kws)",
              "用水量(m3)",
              "用气量(nm3)",
              "用热量(J)",
              "其他能源用量",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            data: [2123, 2542, 3278, 2369, 1986],
          },
          // {
          //   name: "用水量(m3)",
          //   type: "bar",
          //   data: [20],
          // },
          // {
          //   name: "用气量(nm3)",
          //   type: "bar",
          //   data: [55],
          // },
          // {
          //   name: "用热量(J)",
          //   type: "bar",
          //   data: [21],
          // },
          // {
          //   name: "其他能源用量",
          //   type: "bar",
          //   data: [24],
          // },
        ],
      };
    },
    monthlyProportionRate() {
      return {
        title: {
          text: "年度用量同比变化量",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效Rate
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["2020"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "用电量(kws)",
            type: "bar",
            data: [5],
          },
          {
            name: "用水量(m3)",
            type: "bar",
            data: [6],
          },
          {
            name: "用气量(nm3)",
            type: "bar",
            data: [7],
          },
          {
            name: "用热量(J)",
            type: "bar",
            data: [8],
          },
          {
            name: "其他能源用量",
            type: "bar",
            data: [5],
          },
          {
            name: "",
            type: "line",
            yAxisIndex: 1,
            data: [5, 6, 3, 8, 2],
          },
        ],
      };
    },
    monthlyProportionRate2() {
      return {
        title: {
          text: "年度用量同比变化率",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["用电量", "用水量", "用气量", "用热量", "其他能源用量"],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["用电量", "用水量", "用气量", "用热量", "其他能源用量"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            data: [12, 15, 13, 21, 19],
          },
          // {
          //   name: "用水量",
          //   type: "line",
          //   data: [17],
          // },
          // {
          //   name: "用气量",
          //   type: "line",
          //   data: [16],
          // },
          // {
          //   name: "用热量",
          //   type: "line",
          //   data: [11],
          // },
          // {
          //   name: "其他能源用量",
          //   type: "line",
          //   data: [18],
          // },
        ],
      };
    },
    seasonProportion() {
      return {
        title: {
          text: "季度用量",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["一季度", "二季度", "三季度", "四季度"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "用电量(kws)",
            type: "bar",
            data: [20, 12, 23, 26],
          },
          {
            name: "用水量(m3)",
            type: "bar",
            data: [10, 20, 18, 21],
          },
          {
            name: "用气量(nm3)",
            type: "bar",
            data: [45, 55, 47, 65],
          },
          {
            name: "用热量(J)",
            type: "bar",
            data: [8, 21, 12, 32],
          },
          {
            name: "其他能源用量",
            type: "bar",
            data: [10, 24, 28, 45],
          },
        ],
      };
    },
    seasonProportionRate() {
      return {
        title: {
          text: "季度用量同比变化量",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["一季度", "二季度", "三季度", "四季度"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "用电量(kws)",
            type: "bar",
            data: [10, 2, 3, 6],
          },
          {
            name: "用水量(m3)",
            type: "bar",
            data: [10, 2, 8, 2],
          },
          {
            name: "用气量(nm3)",
            type: "bar",
            data: [4, 5, 7, 6],
          },
          {
            name: "用热量(J)",
            type: "bar",
            data: [8, 2, 12, 3],
          },
          {
            name: "其他能源用量",
            type: "bar",
            data: [10, 4, 8, 5],
          },
        ],
      };
    },
    seasonProportionRate2() {
      return {
        title: {
          text: "季度用量同比变化率",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["用电量", "用水量", "用气量", "用热量", "其他能源用量"],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["一季度", "二季度", "三季度", "四季度"],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "用电量",
            type: "line",
            data: [2, 2, 3, 6],
          },
          {
            name: "用水量",
            type: "line",
            data: [10, 2, 8, 2],
          },
          {
            name: "用气量",
            type: "line",
            data: [4, 5, 7, 6],
          },
          {
            name: "用热量",
            type: "line",
            data: [8, 2, 2, 3],
          },
          {
            name: "其他能源用量",
            type: "line",
            data: [10, 2, 8, 5],
          },
        ],
      };
    },
    yearlyProportion() {
      return {
        title: {
          text: "月度用量",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
          align: "right",
          right: 50,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "用电量(kws)",
            type: "bar",
            data: [20, 12, 23, 26, 22, 23, 21, 25, 26, 27, 20, 29],
          },
          {
            name: "用水量(m3)",
            type: "bar",
            data: [20, 12, 23, 26, 22, 23, 21, 25, 26, 27, 20, 29],
          },
          {
            name: "用气量(nm3)",
            type: "bar",
            data: [28, 35, 30, 26, 32, 33, 31, 35, 36, 37, 40, 59],
          },
          {
            name: "用热量(J)",
            type: "bar",
            data: [50, 52, 53, 56, 52, 53, 51, 65, 66, 67, 80, 89],
          },
          {
            name: "其他能源用量",
            type: "bar",
            data: [40, 42, 43, 46, 22, 23, 21, 45, 56, 57, 70, 79],
          },
        ],
      };
    },

    yearlyProportionRate() {
      return {
        title: {
          text: "月度用量同比变化量",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "cross" },
        },
        legend: {
          x: "right",
          right: 50,
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "用电量(kws)",
            type: "bar",
            data: [-5, 5, 7, 6, -9, 6, 9, 11, 3, 3, 4, 6],
          },
          {
            name: "用水量(m3)",
            type: "bar",
            data: [5, 4, 3, 8, -4, 6, 4, 9, 7, 3, 5, 7],
          },
          {
            name: "用气量(nm3)",
            type: "bar",
            data: [3, 2, 5, 7, -5, 8, 4, 8, 3, -2, 7, 8],
          },
          {
            name: "用热量(J)",
            type: "bar",
            data: [-2, 6, 6, 9, 7, 6, 6, -3, 7, 8, 9, 5],
          },
          {
            name: "其他能源用量",
            type: "bar",
            data: [-4, 9, 8, 3, 6, 9, 7, 7, 4, 6, 4, 8],
          },
        ],
      };
    },
    yearlyProportionRate2() {
      return {
        title: {
          text: "月度用量同比变化率",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "cross" },
        },
        legend: {
          x: "right",
          right: 50,
          data: [
            "用电量(kws)",
            "用水量(m3)",
            "用气量(nm3)",
            "用热量(J)",
            "其他能源用量",
          ],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value} %",
            },
          },
        ],
        series: [
          {
            name: "用电量",
            type: "line",
            data: [-5, 5, 7, 6, -9, 6, 9, 11, 3, 3, 4, 6],
          },
          {
            name: "用水量",
            type: "line",
            data: [5, 4, 3, 8, -4, 6, 4, 9, 7, 3, 5, 7],
          },
          {
            name: "用气量",
            type: "line",
            data: [3, 2, 5, 7, -5, 8, 4, 8, 3, -2, 7, 8],
          },
          {
            name: "用热量",
            type: "line",
            data: [-2, 6, 6, 9, 7, 6, 6, -3, 7, 8, 9, 5],
          },
          {
            name: "其他能源用量",
            type: "line",
            data: [-4, 9, 8, 3, 6, 9, 7, 7, 4, 6, 4, 8],
          },
        ],
      };
    },
    toggle(time) {
      if (time === 1) {
        this.initData = this.dayData;
        this.paramsData = [
          { value: this.initData[0].count, name: this.initData[0].name },
          { value: this.initData[1].count, name: this.initData[1].name },
          { value: this.initData[2].count, name: this.initData[2].name },
          { value: this.initData[3].count, name: this.initData[3].name },
        ];
        this.electricityProportionOptions = this.electricityProportion(
          this.paramsData
        );
      }
      if (time === 2) {
        this.initData = this.monthData;
        this.paramsData = [
          { value: this.initData[0].count, name: this.initData[0].name },
          { value: this.initData[1].count, name: this.initData[1].name },
          { value: this.initData[2].count, name: this.initData[2].name },
          { value: this.initData[3].count, name: this.initData[3].name },
        ];
        this.electricityProportionOptions = this.electricityProportion(
          this.paramsData
        );
      }
      if (time === 3) {
        this.initData = this.yearData;
        this.paramsData = [
          { value: this.initData[0].count, name: this.initData[0].name },
          { value: this.initData[1].count, name: this.initData[1].name },
          { value: this.initData[2].count, name: this.initData[2].name },
          { value: this.initData[3].count, name: this.initData[3].name },
        ];
        this.electricityProportionOptions = this.electricityProportion(
          this.paramsData
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.energyOverview {
  margin: 20px;
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .count01,
  .count02,
  .count03 {
    margin-bottom: 10px;
    width: 100%;
    border-radius: 10px;
    text-align: center;
    color: #409eff;
    padding: 20px 20px;
    box-sizing: border-box;
    border: 1px solid #409eff;
    border-top: 5px solid #409eff;
    cursor: pointer;
    h1 {
      font-size: 18px;
      margin: 0;
      font-weight: normal;
    }
    h2 {
      font-size: 30px;
      margin: 0;
      line-height: 60px;
    }
  }
  .count02 {
    color: #67c23a;
    border: 1px solid #67c23a;
    border-top: 5px solid #67c23a;
  }
  .count03 {
    color: #e6a23c;
    border: 1px solid #e6a23c;
    border-top: 5px solid #e6a23c;
  }
  .count04,
  .count05,
  .count06,
  .count07 {
    margin-bottom: 10px;
    width: 100%;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    padding: 20px 20px;
    box-sizing: border-box;
    background: #409eff;
    h1 {
      font-size: 18px;
      margin: 0;
      font-weight: normal;
    }
    h2 {
      font-size: 30px;
      margin: 0;
      line-height: 60px;
    }
  }
  .count05 {
    background: #67c23a;
  }
  .count06 {
    background: #e6a23c;
  }
  .count07 {
    background: #f56c6c;
  }
  .tableTitle {
    font-size: 16px;
  }
}
</style>
